import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import { Grid, Segment, Image } from "semantic-ui-react";
import { ErrorBoundary } from "common-components";
import { Toasts, HNavbar, Responsive } from "hireart-components";
import "../../Common/css/layout.css";

const LoginNavLayout = ({ children }) => {
  const location = useLocation();
  const errorResetKey = location.pathname;

  return (
    <div className="Site overflow-hidden">
      <HNavbar homeRoute="/" logo="/assets/logos/header.svg" />

      <div className="Site-content candidates">
        <Grid className="justify-center">
          <Grid.Row verticalAlign="middle">
            <ErrorBoundary key={errorResetKey}>
              <Grid.Column
                className="login-card"
                computer={7}
                widescreen={3}
                largeScreen={5}
                mobile={16}
                tablet={9}
              >
                <Responsive minWidth={Responsive.onlyMobile.maxWidth}>
                  <Segment compact className="login-top">
                    <Image
                      className="giraffe"
                      src="/assets/giraffe-lg.png"
                      size="tiny"
                    />
                  </Segment>
                </Responsive>

                {children}
              </Grid.Column>
            </ErrorBoundary>
          </Grid.Row>
        </Grid>
      </div>
      <Toasts.Container />
    </div>
  );
};

LoginNavLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default LoginNavLayout;
